import { Table, Thead, Tr, Th, Tbody, Td } from "@chakra-ui/react";
import { StatementEntryViewModel } from "@common/loans/statements/amortization.view-model";
import { useCustomFormats } from "hooks/useCustomFormat";
import { ReactNode } from "react";

export function TableTransactions({
  data,
  tfoot,
}: {
  data: StatementEntryViewModel[];
  tfoot?: ReactNode;
}) {
  const { formatDate, formatCurrency } = useCustomFormats();

  return (
    <Table variant="print">
      <Thead>
        <Tr>
          <Th>Date</Th>
          <Th>Description</Th>
          <Th>Debits</Th>
          <Th>Credits</Th>
          <Th>Cumulative Balance</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data?.map((item, index) => {
          return (
            <Tr key={index}>
              <Td textAlign="center">{formatDate(item.date)}</Td>
              <Td textAlign="left">{item.description}</Td>
              <Td textAlign="right">{formatCurrency(item.debit)}</Td>
              <Td textAlign="right">{formatCurrency(item.credit)}</Td>
              <Td textAlign="right">{formatCurrency(item.balance)}</Td>
            </Tr>
          );
        })}
      </Tbody>
      {tfoot && tfoot}
    </Table>
  );
}
